import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { ExpandableSection } from './ExpandableSection';
function VehicleSpec(props) {
    if (props.customSpec) {
        return props.customSpec(props.value, props.label);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "car-spec-item col-sm-6", children: [_jsx("dt", { children: props.label }), _jsx("dd", { children: props.value })] }) }));
}
function VehicleSpecs({ voertuig }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const specsColumn = [
        // {
        //   id: 'LEASE_DURATION',
        //   label: ss.i18n._t('VehicleSpecifications.LEASE_DURATION'),
        //   value: voertuig.LeaseDuration,
        // },
        // {
        //   id: 'LEASE_MILEAGE',
        //   label: ss.i18n._t('VehicleSpecifications.LEASE_MILEAGE'),
        //   value: voertuig.LeaseMileage,
        // },
        {
            id: 'REGISTRATION_MONTH_YEAR',
            // label: ss.i18n._t('VehicleSpecifications.REGISTRATION_MONTH_YEAR'),
            label: 'Registratie',
            value: voertuig.RegistrationMonthYear,
        },
        {
            id: 'MERK',
            // label: ss.i18n._t('VehicleSpecifications.MERK'),
            label: 'Merk',
            value: voertuig.merk,
        },
        {
            id: 'MODEL',
            // label: ss.i18n._t('VehicleSpecifications.MODEL'),
            label: 'Model',
            value: voertuig.modelH,
        },
        {
            id: 'TYPE',
            // label: ss.i18n._t('VehicleSpecifications.TYPE'),
            label: 'Type',
            value: voertuig.typeClean || voertuig.type,
        },
        {
            id: 'BOUWJAAR',
            // label: ss.i18n._t('VehicleSpecifications.BOUWJAAR'),
            label: 'Bouwjaar',
            value: voertuig.bouwjaar,
        },
        {
            id: 'TELLERSTAND',
            // label: ss.i18n._t('VehicleSpecifications.TELLERSTAND'),
            label: 'Tellerstand',
            value: voertuig.tellerstand,
            customSpec: (value, label) => (_jsx(_Fragment, { children: _jsxs("div", { className: "car-spec-item col-sm-6", children: [_jsx("dt", { children: label }), _jsx("dd", { className: "dd dd--inline", children: _jsxs("div", { className: "dd__label", children: [value, " km"] }) })] }) })),
        },
        {
            id: 'BRANDSTOF',
            //   label: ss.i18n._t('VehicleSpecifications.BRANDSTOF'),
            label: 'Brandstof',
            value: voertuig.brandstof,
            customSpec: (value, label) => {
                let string = 'Onbekend';
                string = voertuig.brandstof === 'B' ? 'Benzine' : string;
                string = voertuig.brandstof === 'D' ? 'Diesel' : string;
                string = voertuig.brandstof === 'L' ? 'LPG/Gas' : string;
                string = voertuig.brandstof === '3' ? 'LPG G3' : string;
                string = voertuig.brandstof === 'E' ? 'Elektrisch' : string;
                string = voertuig.brandstof === 'H' ? 'Hybride' : string;
                string = voertuig.brandstof === 'C' ? 'CNG' : string;
                string = voertuig.brandstof === 'DE' ? 'Hybride diesel' : string;
                string = voertuig.brandstof === 'D,E' ? 'Hybride diesel' : string;
                string = voertuig.brandstof === 'BE' ? 'Hybride benzine' : string;
                string = voertuig.brandstof === 'B,E' ? 'Hybride benzine' : string;
                string = voertuig.brandstof === 'O' ? 'Overig' : string;
                return (_jsx(_Fragment, { children: _jsxs("div", { className: "car-spec-item col-sm-6", children: [_jsx("dt", { children: label }), _jsx("dd", { children: string })] }) }));
            },
        },
        {
            id: 'TRANSMISSIE',
            //   label: ss.i18n._t('VehicleSpecifications.TRANSMISSIE'),
            label: 'Transmissie',
            value: voertuig.transmissie,
            customSpec: (value, label) => {
                let string = 'Onbekend';
                string = voertuig.transmissie === 'H' ? 'Handgeschakeld' : string;
                string = voertuig.transmissie === 'A' ? 'Automaat' : string;
                string = voertuig.transmissie === 'S' ? 'Semi-automaat' : string;
                string = voertuig.transmissie === 'C' ? 'CVT (Continu Variabele Transmissie)' : string;
                return (_jsx(_Fragment, { children: _jsxs("div", { className: "car-spec-item col-sm-6", children: [_jsx("dt", { children: label }), _jsx("dd", { children: string })] }) }));
            },
        },
        {
            id: 'CARROSSERIE',
            //   label: ss.i18n._t('VehicleSpecifications.CARROSSERIE'),
            label: 'Carrosserie',
            value: voertuig.carrosserie,
        },
        {
            id: 'DATUM_DEEL_1',
            //   label: ss.i18n._t('VehicleSpecifications.DATUM_DEEL_1'),
            label: '1<sup>ste</sup> Registratie',
            value: (_a = voertuig.Hexon) === null || _a === void 0 ? void 0 : _a.datum_deel_1,
            customSpec: (value, label) => (_jsx(_Fragment, { children: _jsxs("div", { className: "car-spec-item col-sm-6", children: [_jsx("dt", { dangerouslySetInnerHTML: { __html: label } }), _jsx("dd", { children: value })] }) })),
        },
        {
            id: 'WIELBASIS',
            // label: ss.i18n._t('VehicleSpecifications.WIELBASIS'),
            label: 'Wielbasis',
            value: ((_b = voertuig.Hexon) === null || _b === void 0 ? void 0 : _b.wielbasis) ? `${voertuig.Hexon.wielbasis} cm` : undefined,
        },
        {
            id: 'LAADVERMOGEN',
            // label: ss.i18n._t('VehicleSpecifications.LAADVERMOGEN'),
            label: 'Laadvermogen',
            value: ((_c = voertuig.Hexon) === null || _c === void 0 ? void 0 : _c.laadvermogen) ? `${voertuig.Hexon.laadvermogen} kg` : undefined,
        },
        {
            id: 'MAX_TREKGEWICHT',
            // label: ss.i18n._t('VehicleSpecifications.MAX_TREKGEWICHT'),
            label: 'Max trekgewicht',
            value: ((_d = voertuig.Hexon) === null || _d === void 0 ? void 0 : _d.max_trekgewicht) ? `${voertuig.Hexon.max_trekgewicht} kg` : undefined,
        },
        {
            id: 'AFMETINGEN',
            // label: ss.i18n._t('VehicleSpecifications.AFMETINGEN'),
            label: 'Afmetingen',
            value: (_e = voertuig.Hexon) === null || _e === void 0 ? void 0 : _e.lengte,
            customSpec: (value, label) => {
                if (!voertuig.Hexon)
                    return null;
                if (!voertuig.Hexon.lengte || !voertuig.Hexon.breedte || !voertuig.Hexon.hoogte) {
                    let string = '';
                    string = voertuig.Hexon.lengte ? string + `${voertuig.Hexon.lengte} cm (L)` : string;
                    string = voertuig.Hexon.breedte && string.length > 0 ? string + ' x ' : string;
                    string = voertuig.Hexon.breedte ? string + `${voertuig.Hexon.breedte} cm (B)` : string;
                    string = voertuig.Hexon.hoogte && string.length > 0 ? string + ' x ' : string;
                    string = voertuig.Hexon.hoogte ? string + `${voertuig.Hexon.hoogte} cm (H)` : string;
                    return (_jsx(_Fragment, { children: _jsxs("div", { className: "car-spec-item col-sm-6", children: [_jsx("dt", { children: label }), _jsx("dd", { children: string })] }) }));
                }
                return (_jsx(_Fragment, { children: _jsxs("div", { className: "car-spec-item col-sm-6", children: [_jsx("dt", { children: label }), _jsx("dd", { children: `${voertuig.Hexon.lengte} cm x ${voertuig.Hexon.breedte} cm x ${voertuig.Hexon.hoogte} cm` })] }) }));
            },
        },
        {
            id: 'GVW',
            //   label: ss.i18n._t('VehicleSpecifications.GVW'),
            label: 'GVW',
            value: ((_f = voertuig.Hexon) === null || _f === void 0 ? void 0 : _f.gvw) ? `${voertuig.Hexon.gvw} kg` : undefined,
        },
        {
            id: 'CO2_UITSTOOT',
            //   label: ss.i18n._t('VehicleSpecifications.CO2_UITSTOOT'),
            label: 'CO2-Emissie',
            value: ((_g = voertuig.Hexon) === null || _g === void 0 ? void 0 : _g.co2_uitstoot) ? `${voertuig.Hexon.co2_uitstoot} g/km` : undefined,
        },
        {
            id: 'BTW_MARGE',
            //   label: ss.i18n._t('VehicleSpecifications.BTW_MARGE'),
            label: 'BTW/Marge',
            value: (_h = voertuig.Hexon) === null || _h === void 0 ? void 0 : _h.btw_marge,
            customSpec: (value, label) => {
                if (!voertuig.Hexon)
                    return null;
                let string = 'Onbekend';
                string = voertuig.Hexon.btw_marge === 'B' ? 'BTW' : string;
                string = voertuig.Hexon.btw_marge === 'M' ? 'Marge' : string;
                return (_jsx(_Fragment, { children: _jsxs("div", { className: "car-spec-item col-sm-6", children: [_jsx("dt", { children: label }), _jsx("dd", { children: string })] }) }));
            },
        },
        {
            id: 'BASISKLEUR',
            //   label: ss.i18n._t('VehicleSpecifications.BASISKLEUR'),
            label: 'Kleur',
            value: voertuig.basiskleur,
        },
        {
            id: 'INTERIEURKLEUR',
            //   label: ss.i18n._t('VehicleSpecifications.INTERIEURKLEUR'),
            label: 'Interieur kleur',
            value: (_j = voertuig.Hexon) === null || _j === void 0 ? void 0 : _j.interieurkleur,
        },
        {
            id: 'BEKLEDING',
            //   label: ss.i18n._t('VehicleSpecifications.BEKLEDING'),
            label: 'Bekleding',
            value: (_k = voertuig.Hexon) === null || _k === void 0 ? void 0 : _k.bekleding,
        },
        {
            id: 'VERMOGEN_ALGEMEEN',
            // label: ss.i18n._t('VehicleSpecifications.VERMOGEN_ALGEMEEN'),
            label: 'Vermogen',
            value: voertuig.vermogen_motor_kw || voertuig.vermogen_motor_pk,
            customSpec: (value, label) => {
                if (!(value > 0))
                    return null;
                return (_jsx(_Fragment, { children: _jsxs("div", { className: "car-spec-item col-sm-6", children: [_jsx("dt", { children: label }), _jsx("dd", { children: `${voertuig.vermogen_motor_kw ? voertuig.vermogen_motor_kw + ' kW ' : ''}${voertuig.vermogen_motor_pk ? '(' + voertuig.vermogen_motor_pk + `Pk)` : null}` })] }) }));
            },
        },
        {
            id: 'KENTEKEN',
            // label: ss.i18n._t('VehicleSpecifications.KENTEKEN'),
            label: 'Kenteken',
            value: (_l = voertuig.Hexon) === null || _l === void 0 ? void 0 : _l.kentekenOpgemaakt,
            customSpec: (value, label) => (_jsx(_Fragment, { children: _jsxs("div", { className: "car-spec-item col-sm-6", children: [_jsx("dt", { children: label }), _jsx("dd", { className: "license-plate license-plate--nl license-plate--align-line-height", children: value })] }) })),
        },
        {
            id: 'AANTAL_DEUREN',
            // label: ss.i18n._t('VehicleSpecifications.AANTAL_DEUREN'),
            label: 'Aantal deuren',
            value: ((_m = voertuig.Hexon) === null || _m === void 0 ? void 0 : _m.aantal_deuren) || voertuig.NumberOfDoors,
        },
        {
            id: 'AANTAL_ZITPLAATSEN',
            // label: ss.i18n._t('VehicleSpecifications.AANTAL_ZITPLAATSEN'),
            label: 'Aantal zitplaatsen',
            value: ((_o = voertuig.Hexon) === null || _o === void 0 ? void 0 : _o.aantal_zitplaatsen) || voertuig.NumberOfSeats,
        },
        {
            id: 'NUMBER_OF_GEARS',
            // label: ss.i18n._t('VehicleSpecifications.NUMBER_OF_GEARS'),
            label: 'aantal versnellingen',
            value: ((_p = voertuig.Hexon) === null || _p === void 0 ? void 0 : _p.aantal_versnellingen) || voertuig.NumberOfGears,
        },
        {
            id: 'MASSA',
            // label: ss.i18n._t('VehicleSpecifications.MASSA'),
            label: 'Gewicht',
            value: ((_q = voertuig.Hexon) === null || _q === void 0 ? void 0 : _q.massa) ? voertuig.Hexon.massa + ' kg' : undefined,
        },
        {
            id: 'GEMIDDELD_VERBRUIK',
            // label: ss.i18n._t('VehicleSpecifications.GEMIDDELD_VERBRUIK'),
            label: 'Verbruik',
            value: ((_r = voertuig.Hexon) === null || _r === void 0 ? void 0 : _r.gemiddeld_verbruik) ? voertuig.Hexon.gemiddeld_verbruik + ' l / 100km' : undefined,
        },
        {
            id: 'BIJTELLING_PCT',
            //   label: ss.i18n._t('VehicleSpecifications.BIJTELLING_PCT'),
            label: 'Bijtellingspercentage',
            value: ((_s = voertuig.Hexon) === null || _s === void 0 ? void 0 : _s.bijtelling_pct) ? voertuig.Hexon.bijtelling_pct + '%' : undefined,
        },
        {
            id: 'ONDERHOUDSBOEKJES',
            //   label: ss.i18n._t('VehicleSpecifications.ONDERHOUDSBOEKJES'),
            label: 'Onderhoudsboekjes',
            value: (_t = voertuig.Hexon) === null || _t === void 0 ? void 0 : _t.onderhoudsboekjes,
        },
    ].filter(
    // Only show specs with a value AND a label
    (spec) => spec.value !== undefined &&
        spec.value !== null &&
        spec.value !== '' &&
        spec.label !== undefined &&
        spec.label !== '');
    return (_jsx("div", { className: "detail-content-box detail-content-box--specs", children: _jsx(ExpandableSection, { children: _jsxs(_Fragment, { children: [_jsx("div", { className: "detail-content-heading", children: "Autogegevens" }), _jsx("dl", { className: "vehicle-specs-list row", children: specsColumn.map((spec) => (_jsx(VehicleSpec, { value: spec.value, label: spec.label, customSpec: spec.customSpec }, spec.id))) })] }) }) }));
}
export { VehicleSpecs };
